import { useId } from 'react';

import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { SDSIcon } from '@repo/sds/SDSIcon';
import { SDSSwitch } from '@repo/sds/SDSSwitch';
import { SDSText } from '@repo/sds/SDSText';

import './NotificationOptionItem.scss';

interface NotificationOptionItemProps {
  label: string;
  checked: boolean;
  onChange?: () => void;
  icon: React.ReactElement;
  disabled?: boolean;
  dataTestId?: string;
  labelDataTestId?: string;
}
export function NotificationOptionItem({
  label,
  icon,
  checked,
  onChange,
  disabled,
  dataTestId,
  labelDataTestId,
}: NotificationOptionItemProps) {
  const labelId = useId();

  return (
    <SDSFlexbox className="NotificationOptionItem" justifyContent="space-between" alignItems="center">
      <SDSFlexbox direction="row" gap="no-design-8" alignItems="center">
        <SDSIcon icon={icon} size="small" className="NotificationOptionItem__icon" color="inactive" />
        <SDSText id={labelId} text={label} type="body-medium" dataTestId={labelDataTestId} />
      </SDSFlexbox>
      <SDSSwitch
        aria-labelledby={labelId}
        checked={checked}
        isDisabled={disabled}
        onChange={onChange}
        data-testid={dataTestId}
      />
    </SDSFlexbox>
  );
}
